import { Injectable } from "@angular/core";
import { ImpedimentoAfericao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/impedimento-afericao.entity";
import { MotivoImpedimentoController } from "app/controllers/mob/motivo-impedimento.controller";
import { LoaderService } from "../loader.service";

@Injectable({
    providedIn: "root",
})

export class MotivoImpedimentoService {
    constructor(
        private _motivoImpedimentoController: MotivoImpedimentoController,
        private _loaderService: LoaderService) { }


    async getAll(isLoading: boolean = true): Promise<ImpedimentoAfericao[]> {
        try {
            if (isLoading) this._loaderService.show();
            return await this._motivoImpedimentoController.getAll().finally(() => this._loaderService.hide());
        } catch (error) { return []; }
    }
}